import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import Axios from 'axios-observable';
import axios from 'axios';
import Typography from '@material-ui/core/Typography';
import { Snackbar, Card, CardContent } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import LoaderPopUp from '../loaderpopup/loader';
import SuccessPopUp from '../loaderpopup/success';
import ErrorPopUp from '../loaderpopup/error';
function RazorPay(props) {
    //console.log("before state props",props);
    const [rpProps, setrpProps] = useState(props);
    //console.log("after state props", rpProps);

    React.useEffect(() => {
        setrpProps(props);
    }, [props]);

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            document.body.appendChild(script);
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
        });
    }

    function Alert(props1) {
        return <MuiAlert elevation={6} variant="filled" {...props1} />;
    }
    const [open, setOpen] = React.useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [popUpDisplayMessage, setpopUpDisplayMessage] = React.useState('loading...');
    const [popUpDisplayType, setpopUpDisplayType] = React.useState('info');
    const history = useHistory();

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
    }));

    // const classes = useStyles();

    async function showRazorPay() {
        try {
            const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');
            //console.log("AFTER STATE PROPS:", rpProps);
            //console.log("URL : PASSING : ", rpProps.razorPayProps.postInvoiceIdUrl)
            //console.log("URL : RP : ", rpProps.razorPayProps.bearerToken)
            setShowBtnLoader(true);
            Axios.post(rpProps.razorPayProps.postInvoiceIdUrl, {}, rpProps.razorPayProps.bearerToken).subscribe(
                (result) => {
                    setShowBtnLoader(false);
                    //console.log('Response from First API : ', result); //First from backend
                    //console.log('Response from First API : ', result.data.PaymentHistoryDetails.invoiceId.totalAmount); //First from backend
                    if (result.data) {
                        const resultData = result.data.PaymentHistoryDetails;
                        const options = {
                            key: result.data.RazorPayInfo.apiKey, // Enter the Key ID generated from the Dashboard
                            amount: result.data.PaymentHistoryDetails.invoiceId.totalAmount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                            currency: result.data.PaymentHistoryDetails.currency,
                            name: result.data.RazorPayInfo.displayName,
                            description: result.data.RazorPayInfo.description,
                            order_id: result.data.PaymentHistoryDetails.referenceNumber, // This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                            paymentId: result.data.PaymentHistoryDetails.paymentId,
                            async handler(response) {
                                //console.log("response", response);
                                const data = {
                                    // actualData: resultData,
                                    razorpayPaymentId: response.razorpay_payment_id,
                                    razorpayOrderId: response.razorpay_order_id,
                                    razorpaySignature: response.razorpay_signature,
                                };
                                //console.log("data", data);
                                //console.log("resultData", resultData);
                                resultData.razorpayPaymentId = data.razorpayPaymentId;
                                resultData.razorpayOrderId = data.razorpayOrderId;
                                resultData.razorpaySignature = data.razorpaySignature;
                                const returnedTarget = Object.assign(resultData);
                                //console.log(returnedTarget);
                                //console.log(JSON.stringify(returnedTarget));
                                setShowBtnLoader(true);
                                axios
                                    .post(rpProps.razorPayProps.updatePaymentUrl, returnedTarget, rpProps.razorPayProps.bearerToken)
                                    .then((response) => {
                                        //console.log(response);
                                        // setpopUpDisplayMessage('payment successfull');
                                        // setpopUpDisplayType('success');
                                        // setShowBtnLoader(true);
                                        if (response.status === 200) {
                                            setShowBtnLoader(false);
                                            setSuccessPop(true);
                                        }
                                        handleClick();
                                        // const interval = setInterval(() => {
                                        //     // history.push('/menu/MyInvoices');
                                        //     history.push('/menu/paymenthistory');
                                        // }, 5000);

                                        setTimeout(() => {
                                            history.push('/menu/paymenthistory');
                                        }, 5000);
                                    })
                                    .catch((error) => {
                                        const errResult = error.response;
                                        if (errResult.data) {
                                            setShowBtnLoader(false);
                                            setErrorPop(true);
                                            setTimeout(() => {
                                                setErrorPop(false);
                                            }, 7000);
                                            setErrorMsgGenerateRecceipt(errResult.data.message);
                                            //console.log('update Error : ', error.response);
                                            // setpopUpDisplayMessage(error.response.data.message);
                                            // setpopUpDisplayType('error');
                                            // handleClick();
                                        }
                                    });
                            },
                        };

                        const paymentObject = new window.Razorpay(options);
                        //console.log('paymentObject' + paymentObject);
                        paymentObject.on('payment.failed', function (response) {
                            setpopUpDisplayMessage(response.error.description);
                            setpopUpDisplayType('error');
                            handleClick();
                            //console.log('1-' + response.error.code); //BAD_REQUEST_ERROR
                            //console.log('2-' + response.error.description); //Payment failed
                            //console.log('3-' + response.error.source); //gateway
                            //console.log('4-' + response.error.step); //payment_response
                            //console.log('5-' + response.error.reason); //payment_failed
                            //console.log('6-' + response.error.metadata.order_id); //order_FxUqq7dBtAV5L2
                            //console.log('7-' + response.error.metadata.payment_id); //pay_FxUrNXevJnsr3Q
                        });
                        paymentObject.open();
                    }
                },
                (error) => {
                    setpopUpDisplayMessage(error.response.data.message);
                    setpopUpDisplayType('error');
                    handleClick();
                }
            );
        } catch (error) {
            setpopUpDisplayMessage(error.toString());
            setpopUpDisplayType('error');
            handleClick();
        }
    }

    return (
        <>
            {showBtnLoader ? (
                <LoaderPopUp showLoader={showBtnLoader} handleClose={handleClose} title="Please wait while we processing your request" />
            ) : null}
            <button className="intermediarybutn" onClick={showRazorPay}>
                {/* PAY BY RAZORPAY */}
                Click Here to Pay
            </button>
            {/* <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={popUpDisplayType}>
                    {popUpDisplayMessage}
                </Alert>
            </Snackbar> */}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Payment Done Successfully" />) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />) : null}
        </>
    );
}

export default RazorPay;
